import { FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { CHANNEL_RECORDING_TASK_STATE_TO_LABEL } from '@/features/recorder/constants';
import { ChannelRecordingTaskStateEnum } from '@/features/recorder/types';

const STATUS_CLASSES: Record<ChannelRecordingTaskStateEnum, string> = {
  pending: 'border-[1px] border-accent-active-primary-30 !text-accent-active-primary-30',
  cancelled: 'border-[1px] border-feedback-warning-30 !text-feedback-warning-30',
  running: 'border-[1px] border-feedback-info-30 !text-feedback-info-30 ',
  completed: 'border-[1px] border-feedback-success-30 !text-feedback-success-30',
  error: 'border-[1px] border-feedback-error-30 !text-feedback-error-30',
  paused: 'border-[1px] border-accent-active-secondary-10 !text-accent-active-secondary-10',
  removed: '',
  timeout: 'border-[1px] border-extra-30 !text-extra-30',
  starting: '',
};

export function StatusChipInTable({ status }: { status: ChannelRecordingTaskStateEnum }) {
  const { t } = useTranslation();
  const statusClass = STATUS_CLASSES[status];

  return (
    <div>
      <Typography
        fontSize={FontSizeEnum.Xs}
        weight={FontWeightEnum.Semibold}
        className={clsx(statusClass, 'rounded-sm border-[1px] px-3 py-1 uppercase')}
      >
        {t(CHANNEL_RECORDING_TASK_STATE_TO_LABEL[status])}
      </Typography>
    </div>
  );
}
